import Checkbox from './Checkbox';

export {Checkbox};
export default Checkbox;